import React, { useContext, useState, useEffect } from 'react'
import { DesignContext } from 'contexts/DesignContext'
import ChartSample from 'designer/component/template/chart'
import Loader from 'designer/component/component/Loader'
import { debounceCallback } from 'utility/debounceCallback.util'

const DisplayVirtLayout = () => {
  const designContext = useContext(DesignContext)
  const { jsonForm, openSetting } = designContext
  const { isChart, chart } = jsonForm
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (openSetting) {
      setLoading(true)
    } else {
      setLoading(false)
    }
  }, [openSetting])

  const [render, setRender] = useState(false)

  useEffect(() => {
    setLoading(true)
    debounceCallback(setRender, [true], 'renderChart', 300)
  }, [])

  useEffect(() => {
    if (render) {
      setRender(false)
      setLoading(false)
    }
  }, [render])

  return (
    <div>
      {isChart && (
        <>
          {loading ? (
            <Loader height="240px" />
          ) : (
            <ChartSample chart={chart} renderChart={!openSetting || render} />
          )}
        </>
      )}
    </div>
  )
}

export default DisplayVirtLayout
